module.exports = __webpack_public_path__ + "media/images/weather/257_night-90b8d3277b52d1091d3f71dc1b0e5ebf.png";